import * as React from 'react';
import './LegacyPaymentStatusView.module.scss';
import { observer } from 'mobx-react';
import { PaymentStatus, PaymentShowViewStatus } from '../../../types/payments';
import { MaterialFontIcons } from '../../../../commonv3/components/atoms/icons/icons';
import { LabelText } from '@sheinc/shelikes-design-system';
const classNames = require('classnames');

type PaymentStatusViewProps = {
  paymentStatus: PaymentStatus | PaymentShowViewStatus;
};

/**
 * @deprecated REST API に依存したコンポーネントです。GraphQL APIと使用する場合は PaymentStatusView を使用してください。
 */
export const LegacyPaymentStatusView = observer(({ paymentStatus }: PaymentStatusViewProps) => {
  switch (paymentStatus) {
    case 'paid':
      return (
        <span styleName="payment-status-label">
          <span styleName="icon-wrapper">
            <MaterialFontIcons.CheckBox styleName={classNames('icon', 'unpaid')} />
          </span>
          <LabelText size="XS">決済済み</LabelText>
        </span>
      );
    case 'unpaid':
      return (
        <span styleName="payment-status-label">
          <span styleName="icon-wrapper">
            <MaterialFontIcons.Payment styleName={classNames('icon', 'paid')} />
          </span>
          <LabelText size="XS">決済待ち</LabelText>
        </span>
      );
    case 'refunded':
      return (
        <span styleName="payment-status-label">
          <span styleName="icon-wrapper">
            <MaterialFontIcons.Payment styleName={classNames('icon', 'paid')} />
          </span>
          <LabelText size="XS">返金済み</LabelText>
        </span>
      );
    case 'error':
      return (
        <span styleName="payment-status-label">
          <span styleName="icon-wrapper">
            <MaterialFontIcons.Warning styleName={classNames('icon', 'error')} />
          </span>
          <LabelText size="XS">決済エラー</LabelText>
        </span>
      );
    case 'canceled':
      return (
        <span styleName="payment-status-label">
          <span styleName="icon-wrapper">
            <MaterialFontIcons.Warning styleName={classNames('icon', 'error')} />
          </span>
          <LabelText size="XS">キャンセル済み</LabelText>
        </span>
      );
    default:
      return (
        <span styleName="payment-status-label">
          <LabelText size="XS">不明</LabelText>
        </span>
      );
  }
});
